"use strict";
var NATIVE_SYMBOL = require("../internals/symbol-constructor-detection");
module.exports = NATIVE_SYMBOL && !!Symbol["for"] && !!Symbol.keyFor;
